/**
 * @generated SignedSource<<2733a25bc77edb8d7dad99110b883ddd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ClientDropdown_clients$data = ReadonlyArray<{
  readonly node: {
    readonly id: string;
    readonly name: string;
    readonly logoId: string | null;
  } | null;
  readonly " $fragmentType": "ClientDropdown_clients";
}>;
export type ClientDropdown_clients$key = ReadonlyArray<{
  readonly " $data"?: ClientDropdown_clients$data;
  readonly " $fragmentSpreads": FragmentRefs<"ClientDropdown_clients">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "ClientDropdown_clients",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Client",
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "logoId",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ClientTypeEdge",
  "abstractKey": null
};

(node as any).hash = "7b7436a5a10c6e4fee567fcfc92b395e";

export default node;
